function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { Constants } from "../../../../common/Constants";
import { BroadcastEvent, LogLevel, TelemetryEvent } from "../../../../common/telemetry/TelemetryConstants";
import { TelemetryHelper } from "../../../../common/telemetry/TelemetryHelper";
import { BroadcastService } from "@microsoft/omnichannel-chat-components";
export class HiddenAdaptiveCardActivitySubscriber {
  constructor() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _defineProperty(this, "observer", void 0);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async apply(activity) {
    const {
      attachments,
      attachment
    } = activity;
    this.observer.next(false);
    BroadcastService.postMessage({
      eventName: BroadcastEvent.NewMessageReceived,
      payload: {
        attachments: attachments || [attachment],
        text: "Custom Event"
      }
    });
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  applicable(activity) {
    const {
      attachments,
      attachment
    } = activity;

    // Use `attachments` or `attachment` (whichever exists)
    const cards = attachments || [attachment];

    // Check if contentType is "AdaptiveCard"
    const adaptiveCard = cards === null || cards === void 0 ? void 0 : cards.find(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item => Constants.supportedAdaptiveCardContentTypes.indexOf(item === null || item === void 0 ? void 0 : item.contentType) >= 0);
    if (adaptiveCard && adaptiveCard.content) {
      const {
        body
      } = adaptiveCard.content;
      if (Array.isArray(body)) {
        // Check if all elements in `body` have `isVisible: false`
        const allInvisible = body.every(item => item.isVisible === false);
        if (allInvisible) {
          TelemetryHelper.logLoadingEvent(LogLevel.INFO, {
            Event: TelemetryEvent.HiddenAdaptiveCardMessageReceived,
            Description: "All elements in AdaptiveCard are invisible"
          });
          return true;
        }
      }
    }
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async next(activity) {
    if (this.applicable(activity)) {
      return await this.apply(activity);
    }
    return activity;
  }
}